import React, { useState } from 'react';
import { V } from '../utils/theme';
import { CloudSync } from '../utils/sync';
import { Btn } from './ui';
import { deleteCurrentAccount, deletionPreflight } from '../utils/accountActions';
import { readAccountSession, accountRequest, finishAccountSession } from '../utils/accountSession';

export function AccountControls() {
  const [mode, setMode] = useState(null);
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [deletedSession, setDeletedSession] = useState(null);
  const input = {email, pin, confirmation};
  const finish = async session => {
    if (!await finishAccountSession(session)) throw new Error('Your session changed. Your current account was kept.');
    // Discard old in-memory state, subscriptions and request callbacks before a new login.
    window.location.reload();
  };
  const submit = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try {
      if (mode === 'signout') await finish(readAccountSession());
      else if (deletedSession) await finish(deletedSession);
      else {
        CloudSync.suspend();
        const result = await deleteCurrentAccount(input, {readSession:readAccountSession,
          request:(body, session)=>accountRequest('/api/users', body, session)});
        if (!result.ok) { CloudSync.resume(); throw new Error(result.error); }
        setDeletedSession(result.session); setPin('');
        await finish(result.session);
      }
    } catch (e) { setError(e.message); setBusy(false); }
  };
  const choose = value => {setMode(value);setError('');setPin('');setConfirmation('');setEmail('');};
  const signedIn = !!readAccountSession().token;
  return <div style={{display:'flex',flexDirection:'column',gap:10}}>
    <div style={{fontSize:12,color:V.text2,lineHeight:1.6}}>Sign out removes this browser's saved data, offline queue and draft. Your cloud account stays. Export a backup first if you have unsynced entries.</div>
    {!mode ? <>
      <Btn v="secondary" full disabled={!signedIn} onClick={()=>choose('signout')}>Sign out</Btn>
      <Btn v="secondary" full disabled={!signedIn} onClick={()=>choose('delete')} s={{color:V.danger}}>Delete account</Btn>
      {!signedIn&&<div style={{fontSize:12,color:V.text3}}>Sign in to manage your account.</div>}
    </> : <div style={{padding:12,border:`1px solid ${V.danger}55`,borderRadius:10}}>
      <h3 style={{fontSize:15,marginTop:0}}>{mode==='delete'?'Delete account permanently?':'Sign out of this browser?'}</h3>
      {mode==='delete'&&<p style={{fontSize:12,color:V.text2,lineHeight:1.6}}>This deletes your account and cloud records, then clears this browser. Stored media is queued for removal. This cannot be undone. Organization owners must transfer ownership first.</p>}
      {deletedSession ? <p role="status">Your account was deleted. Retry to finish clearing this browser.</p> : mode==='delete'&&<fieldset disabled={busy} style={{border:0,padding:0,display:'grid',gap:10}}>
        {[['Account email',email,setEmail,'email'],['Current PIN',pin,setPin,'password'],['Type DELETE to confirm',confirmation,setConfirmation,'text']].map(([label,value,set,type])=><label key={label} style={{display:'grid',gap:4,fontSize:12}}>{label}<input type={type} value={value} onChange={e=>set(e.target.value)} autoComplete={type==='password'?'current-password':'off'} style={{padding:12,borderRadius:8,border:`1px solid ${V.cardBorder}`,background:V.card,color:V.text}}/></label>)}
      </fieldset>}
      {error&&<p role="alert" style={{fontSize:12,color:V.danger}}>{error}</p>}
      <div style={{display:'flex',gap:8,marginTop:12}}>
        {!deletedSession&&<Btn v="secondary" full disabled={busy} onClick={()=>choose(null)}>Cancel</Btn>}
        <Btn full disabled={busy||(mode==='delete'&&!deletedSession&&!!deletionPreflight(readAccountSession(),input))} onClick={submit}>{busy?'Please wait…':deletedSession?'Retry browser cleanup':mode==='delete'?'Permanently delete account':'Confirm sign out'}</Btn>
      </div>
    </div>}
    <a href="mailto:support@ironlog.space?subject=Account%20deletion" style={{fontSize:12,color:V.text2}}>Contact support about account deletion</a>
  </div>;
}
